/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import ViewAsUserData from './ViewAsUserSuccess/ViewAsUserData';
import ViewAsUserError from './ViewAsUserError/ViewAsUserError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
  dashboardStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'dashboardStore', 'userStore')
@observer
export default class ViewAsUser extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, formData, userStore }: TypeProps = this.props;

    // selectedUserImpersonate is set on User Management, hence is available only for ISA
    formData.id
      ? actionDrawerStore.impersonateView(formData.id)
      : actionDrawerStore.impersonateView(userStore.selectedUserImpersonate);
  }

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { formData, currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.view_as_user')} />
          <ViewAsUserError user={formData} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      const { dashboardStore } = this.props;

      dashboardStore.removeDashboardFromLocal();

      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.view_as_user')} />
          <ViewAsUserData user={formData} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.view_as_user')} />
      </div>
    );
  }
}
